export const extracurriculars = {
  title: "Atividades Extracurriculares",
  metaDescription: "Atividades extracurriculares na Gándara International School - Inglês, Música, Circo, Imaxina e mais",
  weeklySchedule: {
    title: "Cronograma Semanal",
    filterLabels: {
      english: "Inglês",
      xogos: "Jogos",
      music: "Música", 
      circus: "Circo",
      search: "Procurar atividade… (ex: Inglês)"
    },
    schedule: [
      {
        day: "Segunda-feira",
        subtitle: "English Starters e Imaxina",
        sessions: [
          {
            title: "English Starters Grupo 1",
            time: "15:30 às 16:30",
            instructor: "Patri",
            badge: "3-5 anos",
            tags: ["english"]
          },
          {
            title: "English Starters Grupo 2", 
            time: "16:30 às 17:30",
            instructor: "Patri",
            badge: "3-5 anos",
            tags: ["english"]
          },
          {
            title: "Imaxina",
            time: "16:30 às 18:30",
            instructor: "Xavi",
            badge: "8–12 anos",
            tags: ["imaxina", "criatividade"]
          }
        ]
      },
      {
        day: "Terça-feira",
        subtitle: "English Advance",
        sessions: [
          {
            title: "English Advance Grupo 1",
            time: "15:30 às 16:30",
            instructor: "Sandra",
            badge: "6–12 anos",
            tags: ["english"]
          },
          {
            title: "English Advance Grupo 2",
            time: "16:30 às 17:30", 
            instructor: "Sandra",
            badge: "6–12 anos",
            tags: ["english"]
          }
        ]
      },
      {
        day: "Quarta-feira",
        subtitle: "Jogos de Mesa (8-12 anos)",
        sessions: [
          {
            title: "Jogos de Mesa",
            time: "16:30 às 18:30",
            instructor: "Xavi",
            badge: "8–12 anos",
            tags: ["xogos"]
          }
        ]
      },
      {
        day: "Quinta-feira",
        subtitle: "Oficina de Música e Circo",
        sessions: [
      {
        title: "LET'S PLAY GUITAR",
        time: "15:30 às 16:30",
        instructor: "Óscar",
        badge: "8–12 anos",
        tags: ["music"]
      },
      {
        title: "ENJOY THE MUSIC",
        time: "16:30 às 17:30",
        instructor: "Óscar",
        badge: "5-8 anos",
        tags: ["music"]
      },
          {
            title: "Circo",
            time: "17:30 às 18:30",
            instructor: "",
            badge: "8–12 anos",
            tags: ["circus"]
          }
        ]
      }
    ]
  },
  ludoteca: {
    title: "Serviço de Ludoteca",
    schedule: "Horário da ludoteca: 15:30 às 18:30", 
    freeService: "Gratuito sempre que se tomar almoço ou outra atividade extracurricular",
    pricing: {
      title: "Preços da ludoteca sem almoço nem extracurriculares:",
      dayPass: "Dia avulso: 8€/dia",
      oneDay: "Um dia por semana: 25€/mês",
      twoDays: "Dois dias por semana: 40€/mês",
      fiveDays: "Cinco dias por semana: 100€/mês"
    }
  },
  activities: {
    title: "Atividades Extracurriculares - Preços",
    list: [
      {
        name: "Imaxina",
        age: "8-12 anos",
        price: "40 €/mês",
        description: "Acompanhamento e aprendizagem através de jogos de interpretação"
      },
      {
        name: "Jogos de Mesa",
        age: "8-12 anos",
        price: "40 €/mês",
        description: "Acompanhamento através de jogos de mesa"
      },
      {
        name: "Inglês Lúdico-vivencial",
        age: "3-12 anos",
        price: "40 €/mês",
        description: "Através de jogos, música, artes..."
      },
      {
        name: "Circo em inglês",
        age: "6-12 anos",
        price: "35 €/mês",
        description: "Aprendizagem de técnicas de circo em inglês"
      },
      {
        name: "ENJOY THE MUSIC",
        age: "5-8 anos",
        price: "40 €/mês",
        description: "Iniciação musical para os mais pequenos"
      },
      {
        name: "LET'S PLAY GUITAR",
        age: "8-12 anos",
        price: "40 €/mês",
        description: "Aprendizagem de guitarra para crianças"
      }
    ]
  },
  contact: {
    info: "Mais informações e inscrições",
    description: "Para mais informações e/ou para se inscrever:",
    email: "info@gandaraschool.com"
  }
};